module.exports = __webpack_public_path__ + "img/returning-customers.fe321efc.png";